import { useFrame } from '@react-three/fiber';
import { useRef } from 'react';

const Sun = () => {
	const ref = useRef();

	var time = 0;

	useFrame((_, delta) => {
		if (ref.current.position.x < 4) ref.current.position.x += 0.3 * delta;
		if (ref.current.position.y < -4) ref.current.position.y -= 0.3 * delta;
	});

	return (
		<>
			<directionalLight
				position={[0, 0, -1]}
				target-position={[0,0,0]}
				intensity={6}
				color={'#bbccff'}
				castShadow={false}
				ref={ref}
			/>
			{/* <ambientLight intensity={0.05} color={'#aabbcc'} /> */}
		</>
	);
};

export default Sun;